import apiProxy from '../../services/apiProxy';
import { BRANDING_API } from '../../config/api';

const state = {
	branding: {},
};

const getters = {
	getBranding: (state) => state.branding,
};

const actions = {
	setBranding({ commit }, slug) {
		return apiProxy
			.callPreAuth(BRANDING_API, { brandslug: slug })
			.then(
				(response) => {
					let dataSent = response;
					if (dataSent.code == '1') {
						commit('setNewBranding', dataSent);
						return dataSent;
					} else {
						console.log(dataSent.msg);
					}
				},
				(error) => {
					console.log(error);
				}
			);
	},
};

const mutations = {
	setNewBranding: (state, branding) => (state.branding = branding),
};

export default {
	state,
	getters,
	actions,
	mutations,
};
